
/* User defined models */
import { DynamicFormBase } from './dynamic-form-base.model';

export class ProSchedulerTextbox extends DynamicFormBase<string> {
    controlType = 'textbox';
    type: string;
    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}